import button from './components/button';
import headerImage from './components/headerImage';
import leaderboardRewards from './components/leaderboardRewards';
import style from './components/style';
import footer from './components/footer';
import tinycolor from 'tinycolor2';

module.exports = {
  text: 'New Leaderboard Starting',
  value: 'new-leaderboard',
  usersContext: 'LEADERBOARDS',
  subject: 'There\'s a new leaderboard - starting today',
  mjml(params) {
    const { brandingSettings: branding, leaderboard } = params;
    const slots = params.slots.map(({ content }) => ({
      content: content
        .replace(/{{[\s]*company\.name[\s]*}}/g, '{{defaults company.branding.name company.name "Referrals"}}'),
    }));

    const { prizes } = leaderboard;

    return `<mjml>
      <mj-head>
        <mj-title>${params.subject}</mj-title>
        <mj-include path="../include/styles.mjml"/>
        <mj-attributes>
          <mj-class name="content" background-color="${branding.backgroundColour || '#ffffff'}" border-radius="4px"/>
        </mj-attributes>
        <mj-style>
          ${style(branding)}
        </mj-style>
      </mj-head>

      <mj-body
        width="760px"
        background-color="${branding.backgroundColour || '#ffffff'}"
      >

        ${!branding.hideBrandLogo ? `<mj-section>
          <mj-column>
            <mj-include path="../include/branding-logo.mjml"/>
          </mj-column>
        </mj-section> ` : ''}

        ${branding.headerImage ? headerImage(branding.headerImage) : ''}

        <mj-section mj-class="content">
          <mj-column>
            <mj-text color="${branding.secondaryColour || '#333333'}">
              <div class="text-content">${slots[0].content}</div>
            </mj-text>
          </mj-column>
        </mj-section>

        <mj-section
          padding="44px 16px 12px 16px"
          background-color="${tinycolor(branding.primaryColour || '#dddddd').lighten(46).toString()}"
        >
          <mj-column>
            <mj-text
              font-size="26px"
              line-height="36px"
              align="center"
              font-family="${branding.headerFont || 'Arial'}"
              color="${branding.secondaryColour || '#333333'}"
            >
              <b>${slots[1].content}</b>
            </mj-text>
          </mj-column>
        </mj-section>

        <mj-section background-color="${tinycolor(branding.primaryColour || '#dddddd').lighten(46).toString()}"
          padding="44px 16px 0px 16px">${leaderboardRewards(prizes)}</mj-section>

        <mj-section padding="44px 16px 0px 16px">
          <mj-column padding-bottom="20px" width="100%">
            <mj-text
              font-size="26px"
              align="center"
              line-height="36px"
              font-family="${branding.headerFont || 'Arial'}"
              color="${branding.secondaryColour || '#323232'}"
            >
              <b>${slots[2].content}</b>
            </mj-text>
          </mj-column>
        </mj-section>

        <mj-section padding="0px 16px">
          <mj-column padding-bottom="20px" width="30%">
            <mj-image width="150px" src="${slots[3].content}" />
          </mj-column>
          <mj-column padding-bottom="20px" width="70%">
            <mj-text color="${branding.secondaryColour || '#333333'}">
              <div class="text-content">${slots[4].content}</div>
            </mj-text>
          </mj-column>
        </mj-section>

        <mj-section
          background-color="${tinycolor(branding.primaryColour || '#dddddd').lighten(46).toString()}"
          padding="22px 16px 22px 16px"
        >
          ${slots[5] && slots[5].content ? `<mj-column>${button(slots[5].content, branding)}</mj-column>` : ''}
        </mj-section>

        ${footer(branding)}

        <mj-include path="../include/footer-disclaimer.mjml"/>
      </mj-body>
    </mjml>`;
  },
  slots: [
    {
      name: 'Main Content',
      type: 'html',
      defaultContent: `
        <h1>There's a new leaderboard - start today</h1>
        <p>Don't forget to login to Real Links and start taking actions this month to secure a place on the
        leaderboard. The more you introduce and share content, the more points you collect and the higher
        up the leaderboard you go.</p>
      `,
    },
    {
      name: 'Rewards Title',
      type: 'input',
      defaultContent: 'Rewards available...',
    },
    {
      name: 'Footer Title',
      type: 'input',
      defaultContent: 'Hear from one of last month\'s winners',
    },
    {
      name: 'Footer Picture',
      type: 'input',
      defaultContent: 'https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260',
    },
    {
      name: 'Footer Content',
      type: 'html',
      defaultContent: `
        <p>I introduced [3] connections last month and set myself a target to share
        [15] pieces of company content. And I won an [iPad]!</p>
        <p><b>Shazza Bentley, Global Head of Compliance</b></p>
      `,
    },
    {
      name: 'Button Text',
      type: 'input',
      defaultContent: 'Start Today',
    },
  ],
};



// WEBPACK FOOTER //
// ./src/emails/new-leaderboard.js